module.exports = __webpack_public_path__ + "img/works@2x.18983909.png";